import React, { useState } from 'react';
import { Box, TextField, InputAdornment, MenuItem, Select, IconButton } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CircularProgress from '@mui/material/CircularProgress';

export const WebpageInput = ({ product, onSubmit, loading }) => {
  const [protocol, setProtocol] = useState('https://');
  const [urlPart, setUrlPart] = useState('');
  const [error, setError] = useState('');

  // Validate the full URL using the URL constructor and check that hostname contains a dot.
  const validateUrl = (fullUrl) => {
    try {
      const urlObj = new URL(fullUrl);
      return urlObj.hostname.includes('.');
    } catch (e) {
      return false;
    }
  };

  const handleProtocolChange = (event) => {
    const newProtocol = event.target.value;
    setProtocol(newProtocol);
    const fullUrl = newProtocol + urlPart;
    if (urlPart && !validateUrl(fullUrl)) {
      setError('Invalid URL');
    } else {
      setError('');
    }
  };

  const handleUrlChange = (event) => {
    const inputValue = event.target.value;
    setUrlPart(inputValue);
    const fullUrl = protocol + inputValue;
    if (inputValue && !validateUrl(fullUrl)) {
      setError('Invalid URL');
    } else {
      setError('');
    }
  };

  // Check that the URL is valid and the product prop has at least one character
  const isUrlValid = urlPart && validateUrl(protocol + urlPart);
  const isProductValid = product && product.trim().length > 0;
  const isSubmitEnabled = isUrlValid && isProductValid;

  const handleSubmit = () => {
    if (isSubmitEnabled) {
      onSubmit({
        product: product.trim(),
        url: protocol + urlPart,
      });
    }
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto' }}>
      <TextField
        // label="Webpage URL"
        variant="outlined"
        fullWidth
        error={!!error}
        helperText={error || 'Enter your webpage URL if you would like that I draft a Value proposition for you'}
        value={urlPart}
        onChange={handleUrlChange}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Select
                value={protocol}
                onChange={handleProtocolChange}
                variant="standard"
                disableUnderline
              >
                <MenuItem value="http://">http://</MenuItem>
                <MenuItem value="https://">https://</MenuItem>
              </Select>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {!loading ?
                <IconButton
                  color="primary"
                  onClick={handleSubmit}
                  disabled={!isSubmitEnabled || loading}
                  edge="end"
                >
                  <AutoFixHighIcon />
                </IconButton>
                :
                <CircularProgress
                  size={24}
                />
              }
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};